import type { ReactNode } from 'react'
import { Copy } from 'lucide-react'

interface SectionCardProps {
  title: string
  exportable?: boolean
  copyable?: boolean
  onCopy?: () => void
  children: ReactNode
  className?: string
}

export function SectionCard({ title, exportable, copyable, onCopy, children, className = '' }: SectionCardProps) {
  return (
    <div className={`bg-background-main flex flex-col border-0.5 border-border-main ${className}`}>
      <div className="flex items-center justify-between flex-shrink-0 bg-background-skeleton border-b-0.5 border-border-main" style={{ height: 36, paddingTop: 10, paddingBottom: 10, paddingLeft: 20, paddingRight: 10 }}>
        <span className="font-mulish font-normal text-white" style={{ fontSize: 14, lineHeight: '16px', letterSpacing: '-0.14px' }}>
          {title}
        </span>
        <div className="flex items-center" style={{ gap: 8 }}>
          {copyable && (
            <button
              onClick={onCopy}
              className="flex items-center justify-center text-white bg-background-body border-0.5 border-border-main hover:opacity-80 transition-opacity"
              style={{ width: 24, height: 24 }}
              title="Copy to clipboard"
            >
              <Copy size={14} />
            </button>
          )}
          {exportable && (
            <button
              className="flex items-center justify-center text-white font-jakarta font-normal bg-background-body border-0.5 border-border-main"
              style={{ height: 24, fontSize: 12, lineHeight: '16px', padding: '4px 12px' }}
            >
              Export
            </button>
          )}
        </div>
      </div>
      <div className="flex-1">{children}</div>
    </div>
  )
}

export function ViewMoreLink({ label = 'View more' }: { label?: string }) {
  return (
    <a
      href="#"
      className="font-jakarta text-text-hyperlink hover:underline flex items-center justify-end gap-1"
      style={{ fontSize: 12, lineHeight: '16px', padding: '10px 16px' }}
    >
      {label}
      <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
        <path fillRule="evenodd" clipRule="evenodd" d="M9 3L8.3 3.7L12.05 7.5H1.5V8.5H12.05L8.3 12.3L9 13L14 8L9 3Z" fill="currentColor" />
      </svg>
    </a>
  )
}
